import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setMatchingAirHandlersMode } from 'features/ui';
import { useEffect } from 'react';
import { everyPositionedCondenserHasAirHandler } from 'utils/configurations';

export default function MatchingAirHandlersWatcher() {
  const dispatch = useAppDispatch();
  const matchingAirHandlersMode = useAppSelector(
    (state) => state.ui.matchingAirHandlersMode
  );
  const activeConfiguration = useAppSelector(
    (state) =>
      state.configurations.configurations[state.configurations.activeConfig]
  );
  const requiredModeAvailable =
    everyPositionedCondenserHasAirHandler(activeConfiguration);

  useEffect(() => {
    if (!requiredModeAvailable && matchingAirHandlersMode === 'required') {
      dispatch(setMatchingAirHandlersMode('auto'));
    }
  }, [requiredModeAvailable, matchingAirHandlersMode, dispatch]);

  return null;
}
